"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSTTradeUtils = void 0;
const react_1 = require("react");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
exports.FSTTradeUtils = {
    /**
     * 计算持仓均价
     * @param order
     */
    calcPositionAvgPrice(order) {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const coinInfo = innerOrder.portfolio[0];
        const qty = new trade_utils_lib_1.SafeDecimal(coinInfo.qty_long).add(new trade_utils_lib_1.SafeDecimal(coinInfo.qty_short));
        if (order.isRunning) {
            if (!qty.eq(0)) {
                return new trade_utils_lib_1.SafeDecimal(coinInfo.amount_long)
                    .add(new trade_utils_lib_1.SafeDecimal(coinInfo.amount_short))
                    .add(new trade_utils_lib_1.SafeDecimal(coinInfo.amount_settle))
                    .div(qty)
                    .mul(-1);
            }
            else {
                return new trade_utils_lib_1.SafeDecimal(0);
            }
        }
        else {
            if (coinInfo.side === TradeAPILib_1.ExchangeOrderSide.buy) {
                return new trade_utils_lib_1.SafeDecimal(coinInfo.amount_short).div(new trade_utils_lib_1.SafeDecimal(coinInfo.qty_short)).mul(-1);
            }
            else if (coinInfo.side === TradeAPILib_1.ExchangeOrderSide.sell) {
                return new trade_utils_lib_1.SafeDecimal(coinInfo.amount_long).div(new trade_utils_lib_1.SafeDecimal(coinInfo.qty_long)).mul(-1);
            }
            else {
                return new trade_utils_lib_1.SafeDecimal(0);
            }
        }
    },
    /**
     * 计算预估平仓收益
     * @param innerOrder
     * @param maxDrown
     * @param takerFeeRate
     */
    calcClosePositionPNL(innerOrder, maxDrown, takerFeeRate) {
        const coinInfo = innerOrder.portfolio[0];
        let touchPrice = new trade_utils_lib_1.SafeDecimal(coinInfo.hl_reach_price);
        let closePositionPrice = new trade_utils_lib_1.SafeDecimal(0);
        let qtySum = new trade_utils_lib_1.SafeDecimal(coinInfo.qty_long).add(new trade_utils_lib_1.SafeDecimal(coinInfo.qty_short));
        const avgPrice = !qtySum.equals(0)
            ? new trade_utils_lib_1.SafeDecimal(coinInfo.amount_long)
                .add(new trade_utils_lib_1.SafeDecimal(coinInfo.amount_short))
                .add(new trade_utils_lib_1.SafeDecimal(coinInfo.amount_settle))
                .div(qtySum)
                .mul(-1)
            : new trade_utils_lib_1.SafeDecimal(0);
        closePositionPrice = !qtySum.equals(0)
            ? touchPrice.sub(new trade_utils_lib_1.SafeDecimal(maxDrown).mul(new trade_utils_lib_1.SafeDecimal(innerOrder.quote_invest)).div(qtySum))
            : new trade_utils_lib_1.SafeDecimal(0);
        const unRealizedProfit = new trade_utils_lib_1.SafeDecimal(closePositionPrice).sub(avgPrice).mul(qtySum);
        const closePositionPnl = new trade_utils_lib_1.SafeDecimal(innerOrder.quote_amount)
            .add(unRealizedProfit)
            .sub(new trade_utils_lib_1.SafeDecimal(innerOrder.quote_invest))
            .sub(new trade_utils_lib_1.SafeDecimal(innerOrder.transfer_in).sub(new trade_utils_lib_1.SafeDecimal(innerOrder.transfer_out)))
            .sub(trade_utils_lib_1.SafeDecimal.abs(qtySum).mul(closePositionPrice).mul(new trade_utils_lib_1.SafeDecimal(takerFeeRate)));
        return {
            closePositionPrice: closePositionPrice,
            closePositionPnl: closePositionPnl,
        };
    },
    /**
     *  预估成交价格
     * @param symbol
     * @param investment
     * @param leverage
     * @param side
     * @param $num
     */
    useEstimatedTransactionPrice(symbol, investment, leverage, side, $num) {
        const [limit, setLimit] = (0, react_1.useState)(10);
        const [focus, setFocus] = (0, react_1.useState)(false);
        const orderBookData = (0, trade_quotation_lib_1.useOrderBookData)({
            base: symbol.base,
            quote: symbol.quote,
            limit: limit,
            duration: 5000,
            focused: focus,
        });
        const [avgPrice, setAvgPrice] = (0, react_1.useState)("--");
        const nominalValue = (0, react_1.useMemo)(() => {
            return new trade_utils_lib_1.SafeDecimal(investment).mul(leverage).toNumber();
        }, [investment, leverage]);
        (0, react_1.useEffect)(() => {
            if (nominalValue > 0) {
                setFocus(true);
            }
            else {
                setFocus(false);
                setAvgPrice("--");
            }
        }, [nominalValue]);
        (0, react_1.useEffect)(() => {
            setLimit(10);
        }, [symbol, leverage, side, investment]);
        (0, react_1.useEffect)(() => {
            var _a, _b;
            if (orderBookData === undefined) {
                return;
            }
            if (nominalValue === 0) {
                return;
            }
            let cumValue;
            let index = -1;
            const dataArray = side === TradeAPILib_1.ExchangeOrderSide.buy ? orderBookData.asks : orderBookData.bids;
            while (new trade_utils_lib_1.SafeDecimal(cumValue === null || cumValue === void 0 ? void 0 : cumValue.accVolume).lessThan(nominalValue)) {
                index += 1;
                cumValue = dataArray[index];
                if (index === dataArray.length - 1) {
                    setLimit((prevState) => {
                        if (prevState >= 150) {
                            return 150;
                        }
                        else {
                            return prevState + 10;
                        }
                    });
                    break;
                }
            }
            if (index > 0) {
                const remValue = new trade_utils_lib_1.SafeDecimal(nominalValue).sub(new trade_utils_lib_1.SafeDecimal(dataArray[index - 1].accVolume));
                const q = remValue.div(new trade_utils_lib_1.SafeDecimal(dataArray[index].price)).add(dataArray[index - 1].accQuantity);
                const temp = new trade_utils_lib_1.SafeDecimal(nominalValue).div(q);
                setAvgPrice($num(temp.toNumber(), { precision: (_a = symbol.precision) !== null && _a !== void 0 ? _a : 2 }));
            }
            else {
                setAvgPrice($num(dataArray[index].price, { precision: (_b = symbol.precision) !== null && _b !== void 0 ? _b : 2 }));
            }
        }, [$num, nominalValue, orderBookData, side, symbol.precision]);
        return avgPrice;
    },
};
